module.exports = __webpack_public_path__ + "media/images/shared/rules-webinar-cover-bd8aff444c66f6df6b896146b515d327.jpg";